import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavService } from '../../main/navigation/nav.service';
import { UserService } from '../../shared/services/user.service';
import { UserDisabledStatus } from '../../security/user-disabled-status';

@Component({
  selector: 'townip-error-403',
  templateUrl: './error-403.component.html',
  styleUrls: ['./error-403.component.scss']
})
export class Error403Component implements OnInit {

  public disabledStatus: UserDisabledStatus;

  public disabledStatuses  = UserDisabledStatus;

  public dashboardUrl = '/auth/login';

  constructor(private route: ActivatedRoute,
              private navService: NavService,
              private userService: UserService) { }

  public ngOnInit(): void {
    this.route.queryParams.subscribe(() => {
      this.disabledStatus = this.route.snapshot.queryParamMap.get('disabled') as UserDisabledStatus;
    });

    const user = this.userService.user;
    if (user) {
      this.dashboardUrl = this.navService.goToDashboard(user, true);
    }
  }
}
